import { render, staticRenderFns } from "./SeleccionarCodigosForm.vue?vue&type=template&id=2cef673c&"
import script from "./SeleccionarCodigosForm.vue?vue&type=script&lang=ts&"
export * from "./SeleccionarCodigosForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports